<template>
  <v-container fill-height>
    <v-row justify="center">
      <v-img
        :src="require('@/assets/lpq_logo.png')"
        contain
        eager
        aspect-ratio="1"
        class="welcome-image"
      >
        <span class="center-text welcome-text">{{ $vuetify.lang.t('$vuetify.welcome') }}</span>
      </v-img>
    </v-row>
  </v-container>
</template>

<script>

export default {
  components: {
  },
  data: () => ({
    fadeOut: false
  }),
  methods: {
    test () {
    }
  }
}
</script>

<style>
.welcome-image {
  max-width:80%;
  max-height:300px;
}
.welcome-text {
  display: inline-block;
  font-size: calc(100% + 2.2vw);
  font-weight: bold;
}
.center-text {
  text-align: center;
  width: 100%;
}
</style>
